import React from 'react';
import { Box, Button } from '@mui/material';
import { AgentInlineSelect } from './InlineSelect';
import { AI_AGENT_UI } from './tokens';

export type AgentQuickIntentOption = {
  id: string;
  label: string;
};

type Props = {
  options: AgentQuickIntentOption[];
  value: string;
  onChange: (id: string) => void;
  onGo: () => void;
  disabled?: boolean;
};

/**
 * Quick intents — same workflow as the classic AI Agent picker,
 * restyled for the current Script-like composer chrome.
 */
export function AgentQuickIntents({ options, value, onChange, onGo, disabled }: Props) {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '100%',
        mx: 'auto',
        mb: 1.25,
        flexShrink: 0,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: 1,
          alignItems: 'flex-end',
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <AgentInlineSelect
            id="agent-quick-intent-select"
            label="Choose an action"
            value={value}
            disabled={disabled}
            maxListHeight={240}
            emptyLabel="No actions"
            options={options.map((o) => ({ value: o.id, label: o.label }))}
            onChange={onChange}
            openAbove
          />
        </Box>
        <Button
          variant="contained"
          size="small"
          onClick={onGo}
          disabled={disabled || !value}
          sx={{
            flexShrink: 0,
            minWidth: 64,
            height: 40,
            px: 2,
            mb: 0,
            textTransform: 'none',
            fontWeight: 600,
            fontSize: AI_AGENT_UI.fontSm,
            borderRadius: `${AI_AGENT_UI.radius.sm}px`,
            bgcolor: AI_AGENT_UI.primary,
            boxShadow: 'none',
            '&:hover': { bgcolor: AI_AGENT_UI.primaryDark, boxShadow: 'none' },
            '&.Mui-disabled': {
              bgcolor: AI_AGENT_UI.border,
              color: '#fff',
            },
          }}
        >
          Go
        </Button>
      </Box>
    </Box>
  );
}
